import { ROLES } from './users'

const {
  ADMIN,
  CALL_CENTER_REPRESENTATIVE,
  REGIONAL_MANAGER,
  STORE_MANAGER,
  STORE_REPRESENTATIVE,
  SUPER_ADMIN,
} = ROLES

export type LocationModalPermissions = {
  blockedOffTimes: string[]
  installerId: string[]
  locationInfo: string[]
  spokeLocations: string[]
  tabulationAreas: string[]
  technicianEmails: string[]
  tireLocations: string[]
  websiteScheduleBuffer: string[]
  workingDays: string[]
}

const LOCATION_MODAL_PERMISSION_MAPS: {
  isReadOnlyMap: LocationModalPermissions
  isInvisibleMap: LocationModalPermissions
} = {
  isReadOnlyMap: {
    blockedOffTimes: [
      CALL_CENTER_REPRESENTATIVE,
      STORE_REPRESENTATIVE,
      REGIONAL_MANAGER,
    ],
    installerId: [
      CALL_CENTER_REPRESENTATIVE,
      STORE_MANAGER,
      STORE_REPRESENTATIVE,
      REGIONAL_MANAGER,
    ],
    locationInfo: [
      CALL_CENTER_REPRESENTATIVE,
      STORE_REPRESENTATIVE,
      REGIONAL_MANAGER,
    ],
    spokeLocations: [
      CALL_CENTER_REPRESENTATIVE,
      STORE_MANAGER,
      STORE_REPRESENTATIVE,
    ],
    tabulationAreas: [
      CALL_CENTER_REPRESENTATIVE,
      STORE_MANAGER,
      STORE_REPRESENTATIVE,
      REGIONAL_MANAGER,
    ],
    technicianEmails: [
      CALL_CENTER_REPRESENTATIVE,
      STORE_REPRESENTATIVE,
      REGIONAL_MANAGER,
    ],
    tireLocations: [
      CALL_CENTER_REPRESENTATIVE,
      STORE_REPRESENTATIVE,
      REGIONAL_MANAGER,
    ],
    websiteScheduleBuffer: [
      CALL_CENTER_REPRESENTATIVE,
      STORE_REPRESENTATIVE,
      REGIONAL_MANAGER,
    ],
    workingDays: [
      CALL_CENTER_REPRESENTATIVE,
      STORE_REPRESENTATIVE,
      REGIONAL_MANAGER,
    ],
  },
  isInvisibleMap: {
    blockedOffTimes: [],
    installerId: [],
    locationInfo: [],
    spokeLocations: [],
    tabulationAreas: [],
    technicianEmails: [],
    tireLocations: [],
    websiteScheduleBuffer: [],
    workingDays: [],
  },
}

export { LOCATION_MODAL_PERMISSION_MAPS }
